import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { loginUsuario } from "../js/actions/index";
import "./login.scss";

function MapStateToProps(state){
	return{
		usuario:state.login,
	};
}

function MapDispatchToProps(dispatch){
	return{
		doLogin: (usuario) => dispatch(loginUsuario(usuario)),
	};
}

class LoginConnected extends Component{
	static propTypes = {
		usuario: PropTypes.object,
		doLogin: PropTypes.func,
	}

	state = {
		error:"",
		usuario:"",
		password:"",
	}
	inputChanged = (newVal,input) =>{
		if(this.state[input] !== newVal){
			let newState = {...this.state};
			newState[input] = newVal;
			this.setState(newState);
		}
	}
	doSubmit = (evt) =>{
		fetch("https://cursoecografiavinno.com/tienda/wp-json/jwt-auth/v1/token",
			{
				method: "POST",
				headers: {
					"Accept": "application/json",
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					username: this.state.usuario,
					password: this.state.password,
				})
			})
			.then(response => response.json())
			.then(data => {
				if(data.code && data.code.includes("jwt_auth")){
					this.setState({error:data.message});
				}else {
					let token = data.token;
					fetch("https://cursoecografiavinno.com/tienda/wp-json/wp/v2/users/me",
						{
							method:"GET",
							headers:{
								"Authorization":"Bearer "+data.token,
								"Accept": "application/json",
							},
						}
					)
						.then(response => response.json())
						.then(data => {
							if(data.acf && data.acf.pagado){
								this.props.doLogin({user:data,token:token});
							}else this.setState({error:"No tiene permiso para acceder al cusro"});
						});
				}
			});
		if(evt)evt.preventDefault();
	}
	render(){
		return(
			<div className="login">
				<header>Acceso alumnos</header>
				<div className="error" dangerouslySetInnerHTML={{__html: this.state.error}}></div>
				<form onSubmit={(evt) => this.doSubmit(evt)}>
					<label>Usuario: <input className="user_field" id="username" value={this.state.usuario} onChange={(event) => this.inputChanged(event.target.value,"usuario") }/></label>
					<label>Contraseña: <input type="password" className="pswd_field" id="password" value={this.state.password} onChange={(event) => this.inputChanged(event.target.value,"password")}/></label>
					<button type="submit">Acceder</button>
				</form>
			</div>
		);
	}
}

export default connect(MapStateToProps,MapDispatchToProps) (LoginConnected);